const siteData = {
    name : "WeStream",
    year : new Date().getFullYear(),
    developer : "Michael Perry Tettey",
    devSite : "https://mptettey.vercel.app"
}

export default siteData;